/* ============================================================
   Rush Product cart-page upsell — visibility toggle
   ------------------------------------------------------------
   The rush-product section is ALWAYS rendered server-side; this
   module just toggles a CSS class based on the current cart state
   in response to PUB_SUB_EVENTS.cartUpdate. Avoids re-render race
   conditions, custom-element-upgrade issues, and section caching.

   Hidden when:
     - the cart already contains the rush-order product, OR
     - the cart contains no physical (non-subscription) items.
   ============================================================ */

(function () {
  const SHELL_SEL = '.rush-product-shell';
  const HIDDEN_CLASS = 'rush-product-shell--hidden';
  const RUSH_HANDLE = 'rush-order';

  function shouldHide(items) {
    if (!items || items.length === 0) return true;
    let hasRush = false;
    let hasPhysical = false;
    for (const item of items) {
      if (item && item.handle === RUSH_HANDLE) hasRush = true;
      if (item && !item.selling_plan_allocation) hasPhysical = true;
    }
    return hasRush || !hasPhysical;
  }

  function applyVisibility(items) {
    const shell = document.querySelector(SHELL_SEL);
    if (!shell) return;
    shell.classList.toggle(HIDDEN_CLASS, shouldHide(items));
  }

  function onCartUpdate(event) {
    const cartData = event && event.cartData;
    if (!cartData || !Array.isArray(cartData.items)) return;
    applyVisibility(cartData.items);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(init, 50);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
